import * as angular from "angular";
import type { ControlState } from "./control-state";
import { numberInputValue } from "../numbers";
import template from "./number-control.html";

export interface NumberControlController {
	control: ControlState;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
export class NumberControlController implements angular.IController {
	public input = "";

	private lastWritten?: { value: unknown };

	private currentRuntime?: ControlState["session"]["runtime"];

	private currentPath?: string;

	public $onChanges(): void {
		if(this.currentRuntime === this.control.session.runtime && this.currentPath === this.control.path
			&& this.lastWritten && Object.is(this.lastWritten.value, this.control.value)) {
			return;
		}

		this.currentRuntime = this.control.session.runtime;
		this.currentPath = this.control.path;
		this.lastWritten = undefined;
		this.input = this.control.value == null ? "" : String(this.control.value);
	}

	public change(): void {
		const value = numberInputValue(this.input);
		this.lastWritten = { value };
		this.control.change(value);
	}
}

export default angular.module("vesl.extensions.json-schema.number-control", [])
	.component("jsonSchemaNumberControl", {
		template,
		controller: NumberControlController,
		bindings: { control: "<" }
	})
	.name;
